import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import TextUsePolicy from './TextUsePolicy';
import { selectPaisId } from 'legacyfrontend/redux/selectors/application-selectors';

export default function TermsAndConditions() {
  const { t } = useTranslation(['layout']);
  const paisId = useSelector(selectPaisId);

  return (
    <div className='pt-7 pb-10 py-5 container'>
      <div className='px-12 py-12 bg-white'>
        <h3 className='text-xl text-gray-400 px-8'>
          {paisId === 3
            ? 'Termos de Uso Site respetivamente'
            : paisId === 2
              ? 'Términos y Condiciones Generales'
              : t('footer.useTerms')}
        </h3>
        <div className='text-sm text-gray-400 py-12'>
          <TextUsePolicy paisId={paisId} />
        </div>
      </div>
    </div>
  );
}
